import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import CreatPageForm from './CreatePageForm'
import SubscribeAlert from '../../Pricing/Alert'
import { useAppSelector } from '../../../ReduxToolkit/Hooks'
import GeneratingLoader from '../../../CommonElements/GeneratingLoader/GeneratingLoader'

const CreatePageContainer = () => {
  const user = useAppSelector(state => state.user)
  const { generating } = useAppSelector(state => state.pages);

  return (
    <Container fluid>
      {generating && <GeneratingLoader label="Saving..."/>}

      <Row>
        <Col sm="12">
          {/* <SubscribeAlert /> */}
          <CreatPageForm />
        </Col>
      </Row>
    </Container>
  )
}

export default CreatePageContainer